import React, { Component } from "react";
import get from "lodash/get";
import { css, cx } from "emotion";
import { firebase } from "../../constants";
import { Button, Container, Scroll } from "../../components";
import { Redirect, Route, Switch } from "react-router-dom";
import defaultAverages from "../../assets/default-averages.json";
import DashboardSidebar from "./DashboardSidebar";
import DashboardBlank from "./DashboardBlank";
import DashboardResults from "./DashboardResults";
import DashboardAssessment from "./DashboardAssessment";

// /dashboard               Just logged in, waiting for church data or assessment to load
// /dashboard/new           Take a new assessment (redirects here if brand new account)
// /dashboard/:assessment   Continue taking assessment or view assessment results

class Dashboard extends Component {
  state = {
    initialized: false,
    invited: false, // Has user been invited
    church: null, // Church data from firebase
    averages: null, // Ranking averages from firebase
    menuOpen: false,
  };

  async componentDidMount() {
    console.log({ uid: this.props.user.uid });
    // Get ranking averages
    const averagesRef = firebase.database().ref().child("averages");
    const averagesSnap = await averagesRef.once("value");
    const averages = {};
    Object.keys(defaultAverages).forEach((key) => {
      averages[key] = {
        ...defaultAverages[key],
        ...averagesSnap.val()[key],
      };
    });

    // Check if user has been invited
    const inviteRef = firebase
      .database()
      .ref()
      .child("invite")
      .child(btoa(this.props.user.email));
    const inviteSnap = await inviteRef.once("value");
    const invite = inviteSnap.val();

    // Check if church exists
    const churchRef = firebase
      .database()
      .ref()
      .child("church")
      .child(this.props.user.uid);
    const churchSnap = await churchRef.once("value");
    const church = churchSnap.val();

    // Save church if user has invite but church hasn't been setup yet
    if (invite && !church) {
      await churchRef.set({
        name: invite.churchName,
        email: invite.email,
        location: invite.location || "",
        customCTA: invite.customCTA || "",
        timeCreated: firebase.database.ServerValue.TIMESTAMP,
      });

      await inviteRef.update({ pending: false });
    }

    this.setState({
      initialized: true,
      invited: !!invite,
      averages,
      church,
    });

    // listen to church data
    churchRef.on("value", (snapshot) => {
      this.setState({ church: snapshot.val() });
    });
  }

  componentWillUnmount() {
    // Remove listeners
    firebase
      .database()
      .ref()
      .child("church")
      .child(this.props.user.uid)
      .off("value");
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({ menuOpen: false });
    }
  }

  render() {
    return (
      <div
        className={css`
          width: 100vw;
          height: 100vh;
          display: flex;
          align-items: stretch;
          @media (max-width: 1000px) {
            transform: translateX(${this.state.menuOpen ? 300 : 0}px);
            transition: transform 200ms ease-in-out;
          }
        `}
      >
        <img
          src={require("../../assets/images/background.png")}
          role="presentation"
          className={css`
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
          `}
        />
        <DashboardSidebar
          initialized={this.state.initialized}
          church={this.state.church}
        />
        <Scroll
          className={css`
            position: relative;
            width: 100%;
          `}
        >
          {this.state.menuOpen && (
            <div
              onClick={() => {
                this.setState({ menuOpen: false });
              }}
              className={css`
                &::after {
                  content: "";
                  z-index: 1;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  background-color: rgba(255, 255, 255, 0.8);
                  @media (min-width: 1001) {
                    display: none;
                  }
                }
              `}
            />
          )}
          <Container
            className={css`
              margin: 0;
              @media (min-width: 1001px) {
                display: none;
              }
            `}
          >
            <Button
              kind="outline"
              onClick={() =>
                this.setState({
                  menuOpen: !this.state.menuOpen,
                })
              }
              className={css`
                z-index: 9999;
                position: relative;
                margin-top: 25px;
                visibility: ${this.state.menuOpen ? "hidden" : "visible"};
              `}
            >
              Menu
            </Button>
          </Container>
          <Switch>
            <Route
              path="/dashboard/new"
              render={() => <DashboardBlank user={this.props.user} />}
            />
            <Route
              path="/dashboard/:assessment"
              render={({ match }) => {
                const assessment = get(this.state, `church.assessments.${match.params.assessment}`) // prettier-ignore
                if (assessment) {
                  if (assessment.timeSubmitted) {
                    // Assessment is complete, show results
                    return (
                      <DashboardResults
                        church={this.state.church}
                        averages={this.state.averages}
                        responses={assessment.responses}
                        timeSubmitted={assessment.timeSubmitted}
                      />
                    );
                  } else {
                    // Assessment is in progress, show questions
                    return (
                      <DashboardAssessment
                        user={this.props.user}
                        responses={assessment.responses}
                        assessmentKey={match.params.assessment}
                        key={match.params.assessment}
                      />
                    );
                  }
                }

                // Assessment is loading
                return "Loading...";
              }}
            />
            {/* No dashboard route specified */}
            <Route
              render={() => {
                if (!this.state.initialized) {
                  return "Loading...";
                }

                if (!this.state.invited) {
                  return (
                    <div style={{ padding: "0 2rem" }}>
                      <h1>Not Started</h1>
                      <p style={{ maxWidth: "30em" }}>
                        This email address does not yet have access to Vital
                        Signs. Please contact{" "}
                        <a href="mailto:help@theunstuckgroup.com">
                          help@theunstuckgroup.com
                        </a>{" "}
                        for details about getting started.
                      </p>
                    </div>
                  );
                }

                if (!this.state.church || !this.state.church.assessment) {
                  return <Redirect to="/dashboard/new" />;
                }

                const key = Object.keys(this.state.church.assessments)[0];
                return <Redirect to={`/dashboard/${key}`} />;
              }}
            />
          </Switch>
        </Scroll>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/screens/dash/Dashboard.js